module.exports = __webpack_public_path__ + "fc16469df7f2b97e4a74d402bd16a385.svg";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-bold-webfont.svg
// module id = 309
// module chunks = 0